export const workHistory = [
    {
        "role": "Associate Software Engineer",
        "company": "Goldman Sachs",
        "tenure": "Nov 2024 - Present",
        "actions": [
            "Successfully migrated 8 critical web services from Spring Boot v2 with Java 8 to Spring Boot v3.4.0 with Java 21, ensuring compatibility while leveraging new features to enhance performance and scalability.",
            "Built an end-to-end automation system for processing data from CSV/JSON via SFTP and cron, reducing manual workload and processing time by over 80%.",
            "Implemented scalable data ingestion into a Lakehouse system, ensuring high availability and accuracy of datasets consumed by multiple internal teams."
        ]
    },
    {
        "role": "Full Stack Developer II",
        "company": "FedEx ACC",
        "tenure": "Nov 2023 - Nov 2024",
        "actions": [
            "Optimized DB performance, significantly reducing DB query response time by 50% (from 13 seconds to 7 seconds) through advanced query tuning and database partitioning technique.",
            "Enhanced a package-sorting application’s efficiency in FedEx facilities by 30%, improving scalability and handling millions of database records seamlessly.",
            "Strengthened fault tolerance by implementing error-handling and retry mechanisms in distributed services."

        ]
    },
    {
        "role": "Software Development Engineer II",
        "company": "UST Global",
        "tenure": "July 2022 - Nov 2023",
        "actions": [
            "Designed and developed an event-driven system with Apache Kafka, enabling real-time data processing, reducing contract creation time by 30% and improving system throughput by handling over 500,000 events daily.",
            "Reduced application load time by 30% through code optimization, database indexing, and caching.",
            "Engineered a fault-tolerant architecture using circuit breakers and bulkheads, increasing system uptime and reliability by 15% for critical business operations.",
            "Improved throughput and responsiveness by 20% with non-blocking, asynchronous programming using Spring WebFlux.",
            "Implemented distributed tracing with OpenTelemetry, enhancing observability and enabling faster identification and resolution of performance bottlenecks across microservices."

        ]
    },
    {
        "role": "Systems Engineer",
        "company": "Tata Consultancy Services",
        "tenure": "July 2020 - July 2022",
        "actions": [
            "Led the migration of a legacy monolith application to microservices architecture increasing scalability by 70%.",
            "Boosted unit test coverage from 28% to 80%, ensuring robust code validation and reducing production defects.",
            "Enhanced system performance by optimizing Hibernate ORM usage and fine-tuning database interactions.",
            "Collaborated with cross-functional teams including UI/UX designers, QA engineers, and product managers and earned multiple awards for my work and for delivering bug free code on time.",
        ]
    }
];